export default "__VITE_ASSET__0bb6111c__"